import { createSlice } from '@reduxjs/toolkit';
import { DisputeRoutingRule } from '@dill/dill-shared';
import {
  getSupplierDisputeRoutingRulesExtraReducer,
  createDisputeRoutingRuleExtraReducer,
  updateDisputeRoutingRuleExtraReducer,
  deleteDisputeRoutingRuleExtraReducer,
} from '../reducers/disputeRoutingRuleReducers';

export interface DisputeRoutingRuleInitialState {
  loadingList: string[];
  error: string | null;
  rules: DisputeRoutingRule[];
}

const initialState: DisputeRoutingRuleInitialState = {
  loadingList: [],
  error: null,
  rules: [],
};

export const disputeRoutingRuleSlice = createSlice({
  name: 'disputeRoutingRules',
  initialState,
  reducers: {
    resetDisputeRoutingRuleRootState: () => initialState,
  },
  extraReducers(builder) {
    getSupplierDisputeRoutingRulesExtraReducer(builder);
    createDisputeRoutingRuleExtraReducer(builder);
    updateDisputeRoutingRuleExtraReducer(builder);
    deleteDisputeRoutingRuleExtraReducer(builder);
  },
});

export const { resetDisputeRoutingRuleRootState } = disputeRoutingRuleSlice.actions;
